import { render, staticRenderFns } from "./EditarConvocatoriasDialogComponent.vue?vue&type=template&id=b9279d02&scoped=true"
import script from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarConvocatoriasDialogComponent.vue?vue&type=style&index=0&id=b9279d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9279d02",
  null
  
)

export default component.exports